<template>
  <b-container fluid>
    <b-row>
      <div class="col-xl-3 col-md-6 pb-3">
        <stats-card class="card-stats-big-numbers">
          <div slot="header" class="icon-danger">
            <i class="nc-icon nc-vector text-warning">Units full at terminal</i>
          </div>
          <div slot="content">
            <p class="card-category"></p>
            <h4 class="card-title">
              <b-link to="/portal/unitsatterminal">
                {{
                account.qty_unit_full_at_terminal | numFormat(interger_format)
                }}
              </b-link>
            </h4>
          </div>
          <div slot="footer" class="d-flex justify-content-center">
            <span>
              <b-link to="/portal/unitsatterminal?only_units_with_AR=true">
                <span><i> Accrued : </i></span>{{
                accrued_charge_at_terminal_less_than_366_days | numFormat(currency_format)
                }}
              </b-link>
            </span>
          </div>
        </stats-card>
      </div>

      <div class="col-xl-3 col-md-6 pb-3">
        <stats-card class="card-stats-big-numbers">
          <div slot="header" class="icon-danger">
            <i class="nc-icon nc-vector text-primary">Units full at consignee</i>
          </div>
          <div slot="content">
            <p class="card-category"></p>
            <h4 class="card-title">
              <b-link to="/portal/unitsatconsignee">
                {{
                account.qty_unit_full_at_consignee
                | numFormat(interger_format)
                }}
              </b-link>
            </h4>
          </div>
          <div slot="footer" class="d-flex justify-content-center">
            <span>
              <b-link to="/portal/unitsatconsignee?only_units_with_AR=true">
                <span><i> Accrued : </i></span>{{
                accrued_charge_at_consignee
                | numFormat(currency_format)
                }}
              </b-link>
            </span>
          </div>
        </stats-card>
      </div>

      <div class="col-xl-3 col-md-6 pb-3">
        <stats-card class="card-stats-big-numbers">
          <div slot="header" class="icon-warning">
            <i class="nc-icon nc-chart text-danger">Total outstanding</i>
          </div>
          <div slot="content">
            <p class="card-category"></p>
            <h4 class="card-title">
              <b-link to="/portal/outstandings">
                <span
                  class="text-danger"
                >{{ accrued_outstanding_amount | numFormat(currency_format) }}</span>
              </b-link>
            </h4>
          </div>
          <div slot="footer" class="d-flex justify-content-center">
            Last 30 days : {{ accrued_outstanding_amount_last_30_days | numFormat(currency_format) }}
          </div>
        </stats-card>
      </div>

      <div class="col-xl-3 col-md-6 pb-3">
        <stats-card class="card-stats-big-numbers">
          <div slot="header" class="icon-warning">
            <i class="nc-icon nc-chart text-info">Collection</i>
          </div>
          <div slot="content">
            <p class="card-category"></p>
            <h4 class="card-title">
              {{
              ((account.collected_demurrage_amount || 0) + (account.collected_detention_amount || 0)) | numFormat(currency_format) 
              }}
            </h4>
          </div>
          <div slot="footer" class="d-flex justify-content-between">
            <span>
              DEM : {{
              (account.collected_demurrage_amount || 0)/1000 | numFormat 
              }} K
            </span>
            <span>|</span>
            <span>
              DET : {{
              (account.collected_detention_amount || 0)/1000 | numFormat 
              }} K
            </span>
          </div>
        </stats-card>
      </div>
    </b-row>
    
    <b-row class="pb-3" v-show="show_units_at_terminal_section">
      <b-card class="dashboard-section">
        <b-card-title>
          <i
            class="fa float-right"
            :class="collapse_units_at_terminal_section ? 'fa-plus' : 'fa-minus'"
            aria-hidden="true"
            @click="
              collapse_units_at_terminal_section = !collapse_units_at_terminal_section
            "
          ></i>
          <i
            class="fa float-right pr-3"
            :class="show_graph_in_units_at_terminal_section ? 'fa-th' : 'fa-chart-bar'"
            aria-hidden="true"
            @click="
              show_graph_in_units_at_terminal_section = !show_graph_in_units_at_terminal_section
            "
            v-show="!collapse_units_at_terminal_section"
          ></i>
          Units full at terminal
        </b-card-title>
        <div class="row" v-show="!collapse_units_at_terminal_section && show_graph_in_units_at_terminal_section">
          <div class="col-md-6">
            <b-card>
              <apexchart
                type="bar"
                :options="units_at_terminal_chart.options"
                :series="units_at_terminal_chart.series"
                :height="graph_height"
                :width="graph_width"
              ></apexchart>
            </b-card>
          </div>
          <div class="col-md-6">
            <b-card>
              <apexchart
                type="bar"
                :options="units_at_terminal_ar_chart.options"
                :series="units_at_terminal_ar_chart.series"
                :height="graph_height"
                :width="graph_width"
              ></apexchart>
            </b-card>
          </div>
        </div>
        <div class="row" v-show="accrued_charge_at_terminal_over_365_days>0">
          <div class="col-xl-12 col-md-12 alert alert-warning" role="alert">
            <span> *Units full at terminal with 365 days or more : {{accrued_charge_at_terminal_over_365_days  | numFormat(currency_format)}} </span>
          </div>
        </div>
        <div class="row" v-show="!collapse_units_at_terminal_section && !show_graph_in_units_at_terminal_section">
          <div class="col-xl-12 col-md-12 pb-1">
            <b-card v-show="!show_units_at_terminal">
              <arRecap
                :show_age="true"
                :recap_data="units_at_terminal_recap"
                :show_details="onShowUnitsAtTerminalDetails"
                :refresh_data="onRefreshUnitsAtTerminal"
              />
            </b-card>
            <units_list v-show="show_units_at_terminal" :hide_details="()=>show_units_at_terminal=false" search_type="FULL_AT_TERMINAL" :search_bar="false" />
          </div>
        </div>
      </b-card>
    </b-row>

    <b-row class="pb-3" v-if="show_units_at_consignee_section">
      <b-card class="dashboard-section">
        <b-card-title>
          <i
            class="fa float-right"
            :class="collapse_units_at_consignee_section ? 'fa-plus' : 'fa-minus'"
            aria-hidden="true"
            @click="
              collapse_units_at_consignee_section = !collapse_units_at_consignee_section
            "
          ></i>
          <i
            class="fa float-right pr-3"
            :class="show_graph_in_units_at_consignee_section ? 'fa-th' : 'fa-chart-bar'"
            aria-hidden="true"
            @click="
              show_graph_in_units_at_consignee_section = !show_graph_in_units_at_consignee_section
            "
            v-show="!collapse_units_at_consignee_section"
          ></i>
          Units full at consignee
        </b-card-title>
        <div
          class="row"
          v-show="
            !collapse_units_at_consignee_section &&
              show_graph_in_units_at_consignee_section
          "
        >
          <div class="col-md-6">
            <b-card>
              <apexchart
                type="bar"
                :options="units_at_consignee_chart.options"
                :series="units_at_consignee_chart.series"
                :height="graph_height"
                :width="graph_width"
              ></apexchart>
            </b-card>
          </div>
          <div class="col-md-6">
            <b-card>
              <apexchart
                type="bar"
                :options="units_at_consignee_ar_chart.options"
                :series="units_at_consignee_ar_chart.series"
                :height="graph_height"
                :width="graph_width"
              ></apexchart>
            </b-card>
          </div>
        </div>
        <div
          class="row"
          v-show="
            !collapse_units_at_consignee_section &&
              !show_graph_in_units_at_consignee_section
          "
        >
          <div class="col-xl-12 col-md-12 pb-1">
            <b-card v-show="!show_units_at_consignee">
              <arRecap
                :show_age="true"
                :recap_data="units_at_consignee_recap"
                :show_details="onShowUnitsAtConsigneeDetails"
                :refresh_data="onRefreshUnitsAtConsignee"
              />
            </b-card>
            <units_list v-show="show_units_at_consignee" :hide_details="()=>show_units_at_consignee=false" search_type="FULL_AT_CONSIGNEE" :search_bar="false" />
          </div>
        </div>
      </b-card>
    </b-row>

    <b-row class="pb-3" v-if="show_outstanding_section">
      <b-card class="dashboard-section">
        <b-card-title>
          <i
            class="fa float-right"
            :class="collapse_outstanding_section ? 'fa-plus' : 'fa-minus'"
            aria-hidden="true"
            @click="
              collapse_outstanding_section = !collapse_outstanding_section
            "
          ></i>
          <i
            class="fa float-right pr-3"
            :class="show_graph_in_outstanding_section ? 'fa-th' : 'fa-chart-bar'"
            aria-hidden="true"
            @click="
              show_graph_in_outstanding_section = !show_graph_in_outstanding_section
            "
            v-show="!collapse_outstanding_section"
          ></i>
          <span>
            Outstanding
            <b-spinner
              v-if="outstanding_is_loading"
              variant="primary"
              type="grow"
              label="Spinning"
            ></b-spinner>
          </span>
        </b-card-title>
        <div
          class="row"
          v-show="
            !collapse_outstanding_section && show_graph_in_outstanding_section
          "
        >
          <div class="col-md-6">
            <b-card>
              <apexchart
                type="bar"
                :options="outstanding_chart.options"
                :series="outstanding_chart.series"
                :height="graph_height"
                :width="graph_width"
              ></apexchart>
            </b-card>
          </div>
          <div class="col-md-6">
            <b-card>
              <apexchart
                type="bar"
                :options="outstanding_age_chart.options"
                :series="outstanding_age_chart.series"
                :height="graph_height"
                :width="graph_width"
              ></apexchart>
            </b-card>
          </div>
        </div>
        <div
          class="row"
          v-show="
            !collapse_outstanding_section && !show_graph_in_outstanding_section
          "
        >
          <div class="col-xl-12 col-md-12 pb-1">
            <b-card  v-show="!show_units_with_outstanding">
              <arRecap
                :show_age="true"
                :recap_data="units_with_outstanding_recap_top_10"
                :show_details="onShowOutstandingDetails"
                :refresh_data="onRefreshOutstanding"
              />
            </b-card>
            <units_list v-show="show_units_with_outstanding" :hide_details="()=>show_units_with_outstanding=false" search_type="UNPAID_EMPTY_UNITS" :search_bar="false" />
          </div>
        </div>
      </b-card>
    </b-row>
    
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import StatsCard from "@/Cards/HStatsCard.vue";
import arRecap from "@/components/portal/global/UnitsSummary.vue";
import units_list from "@/components/portal/global/ContainerList.vue";
export default {
  components: {
    StatsCard,
    arRecap,
    units_list,
  },
  data: function () {
    return {
      modalShow: false,
      currency_format: "$ 0,0.00",
      interger_format: "0,0",

      collapse_units_at_terminal_section: false,
      collapse_units_at_consignee_section: false,
      collapse_outstanding_section: false,

      show_graph_in_units_at_terminal_section: true,
      show_graph_in_units_at_consignee_section: true,
      show_graph_in_outstanding_section: true,

      show_units_at_terminal: false,
      show_units_at_consignee: false,
      show_units_with_outstanding: false,

      graph_height: "250px",
      graph_width: "100%",
      palette: "palette6",
    };
  },
  computed: {
    ...mapGetters([
      "account",
      "units_at_terminal_recap",
      "units_at_consignee_recap",
      "units_with_outstanding_recap",
      "units_recap",
    ]),

    units_at_terminal_recap_top_10() {
      return [...this.units_at_terminal_recap]
        .sort((a, b) => {
          return b.number_of_units - a.number_of_units;
        })
        .slice(0, 10);
    },
    
    units_at_terminal_ar_recap_top_10() {
      return [...this.units_at_terminal_recap]
        .sort((a, b) => {
          return b.unpaid_demurrage - a.unpaid_demurrage;
        })
        .slice(0, 10);
    },

    units_at_consignee_recap_top_10() {
      return [...this.units_at_consignee_recap]
        .sort((a, b) => {
          return b.number_of_units - a.number_of_units;
        })
        .slice(0, 10);
    },
    
    units_at_consignee_ar_recap_top_10() {
      return [...this.units_at_consignee_recap]
        .sort((a, b) => {
          return (b.unpaid_demurrage + b.unpaid_detention + b.unpaid_chassis)
            - (a.unpaid_demurrage + a.unpaid_detention + a.unpaid_chassis);
        })
        .slice(0, 10);
    },
    
    units_with_outstanding_recap_top_10() {
      return [...this.units_with_outstanding_recap]
        .sort((a, b) => {
          return (b.unpaid_demurrage + b.unpaid_detetention + b.unpaid_chassis)
            - (a.unpaid_demurrage + a.unpaid_detetention + a.unpaid_chassis);
        })
        .slice(0, 10);
    },
    accrued_outstanding_amount() {
      return this.units_with_outstanding_recap.reduce(
        (amount, AR) => amount + (AR.unpaid_demurrage+AR.unpaid_detention),
        0
      );
    },
    accrued_outstanding_amount_last_30_days() {
      return this.units_with_outstanding_recap.reduce(
        (amount, AR) => (amount += AR.j0_30 || 0), 
        0
      )
    },
    show_outstanding_section() {
      return this.units_with_outstanding_recap.length != 0;
    },
    outstanding_is_loading() {
      return (
        this.account.total_unpaid_amount > 0 &&
        this.units_with_outstanding_recap.length == 0
      );
    },
    show_units_at_terminal_section() {
      return !this.account.qty_unit_full_at_terminal == 0;
    },
    show_units_at_consignee_section() {
      return !this.account.qty_unit_full_at_consignee == 0;
    },
    debt_date() {
      var datetime = new Date();
      return datetime.toISOString().slice(0, 10);
      //Debts as of April 19th, 2020
    },
    accrued_charge_at_terminal() {
      return this.units_at_terminal_recap.reduce(
        (amount, AR) => amount + AR.unpaid_demurrage,
        0
      );
    },
    accrued_charge_at_terminal_less_than_366_days() {
      return this.units_at_terminal_recap.reduce(
        (amount, AR) => {
            amount += AR.hasOwnProperty('j0_30') ? AR.j0_30 : 0;
            amount += AR.hasOwnProperty('j31_90') ? AR.j31_90 : 0;
            amount += AR.hasOwnProperty('j91_180') ? AR.j91_180 : 0;
            amount += AR.hasOwnProperty('j181_365') ? AR.j181_365 : 0;
            return amount
          }, 
        0
      )
    },
    accrued_charge_at_terminal_over_365_days() {
      return this.units_at_terminal_recap.reduce(
        (amount, AR) => (amount += AR.hasOwnProperty('j366_0') ? AR.j366_0 : 0), 
        0
      )
    },
    accrued_charge_at_consignee() {
      return this.units_at_consignee_recap.reduce(
        (amount, AR) =>
          amount +
          (AR.unpaid_demurrage + AR.unpaid_detention + AR.unpaid_chassis),
        0
      );
    },


    units_at_terminal_chart() {
      return {
        options: {
          chart: {
            id: "chart-units-at-terminal",
            
          },
          title: {
            text: "Number of units",
          },
          noData: {
            text: "Loading...",
          },
          plotOptions: {
            bar: {
              horizontal: true,
              position: "top",
            },
          },
          theme: {
            palette: this.palette,
          },
          xaxis: {
            categories: this.units_at_terminal_recap_top_10.map((x) => {
              return x.customer_name;
            }),
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: "10px",
            },
            formatter: function (value) {
              return  value >= 1000 ? parseInt(value/1000) + "K": value;
            },
          },
        },
        series: [
          {
            name: "number of units",
            unpaid_demurrage: this.units_at_terminal_recap_top_10.map(
              (x) => x.unpaid_demurrage
            ),
            data: this.units_at_terminal_recap_top_10.map((x) => x.number_of_units),
          },
        ],
      };
    },

    units_at_terminal_ar_chart() {
      return {
        options: {
          chart: {
            id: "chart-units-at-terminal_ar",
            stacked: true,
          },
          title: {
            text: "Accrued demurrage",
          },
          noData: {
            text: "Loading...",
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          theme: {
            palette: this.palette,
          },
          xaxis: {
            categories: this.units_at_terminal_ar_recap_top_10.map((x) => x.customer_name),
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: "10px",
            },
            formatter: function (value) {
              return  value >= 1000 ? parseInt(value/1000) + "K": value;
            },
          },
        },
        series: [
          {
            name: "Demurrage",
            data: this.units_at_terminal_ar_recap_top_10.map((x) => x.unpaid_demurrage),
          },
        ],
      };
    },

    units_at_consignee_chart() {
      return {
        options: {
          chart: {
            id: "chart-units-at-consignee",
            stacked: true,
          },
          title: {
            text: "Number of units",
          },
          noData: {
            text: "Loading...",
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          theme: {
            palette: this.palette,
          },
          xaxis: {
            categories: this.units_at_consignee_recap_top_10.map(
              (x) => x.customer_name
            ),
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: "10px",
            },
            formatter: function (value) {
              return  value >= 1000 ? parseInt(value/1000) + "K": value;
            },
          },
        },
        series: [
          {
            name: "number of units",
            data: this.units_at_consignee_recap_top_10.map((x) => x.number_of_units),
          },
        ],
      };
    },

    units_at_consignee_ar_chart() {
      return {
        options: {
          chart: {
            id: "chart-units-at-consignee_ar",
            stacked: true,
          },
          title: {
            text: "Accrued Charges",
          },
          noData: {
            text: "Loading...",
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          theme: {
            palette: this.palette,
          },
          xaxis: {
            categories: this.units_at_consignee_ar_recap_top_10.map(
              (x) => x.customer_name
            ),
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: "10px",
            },
            formatter: function (value) {
              return  value >= 1000 ? parseInt(value/1000) + "K": value;
            },
          },
        },
        series: [
          {
            name: "Demurrage",
            data: this.units_at_consignee_ar_recap_top_10.map((x) => x.unpaid_demurrage),
          },
          {
            name: "Detention",
            data: this.units_at_consignee_ar_recap_top_10.map((x) => x.unpaid_detention),
          },
          {
            name: "Chassis",
            data: this.units_at_consignee_ar_recap_top_10.map((x) => x.unpaid_chassis),
          },
        ],
      };
    },
     
    outstanding_chart() {
      return {
        options: {
          chart: {
            id: "chart-outstanding",
            stacked: true,
          },
          noData: {
            text: "Loading...",
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          theme: {
            palette: this.palette,
          },
          xaxis: {
            categories: this.units_with_outstanding_recap_top_10.map(
              (x) => x.customer_name
            ),
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: "10px",
            },
            formatter: function (value) {
              return  value >= 1000 ? parseInt(value/1000) + "K": value;
            },
          },
        },
        series: [
          {
            name: "Demurrage",
            data: this.units_with_outstanding_recap_top_10.map(
              (x) => x.unpaid_demurrage
            ),
          },
          {
            name: "Detention",
            data: this.units_with_outstanding_recap_top_10.map(
              (x) => x.unpaid_detention
            ),
          },
          {
            name: "Chassis",
            data: this.units_with_outstanding_recap_top_10.map(
              (x) => x.unpaid_chassis
            ),
          },
        ],
      };
    },

    outstanding_age_chart() {
      return {
        options: {
          chart: {
            id: "chart-outstanding-age",
            stacked: true,
          },
          noData: {
            text: "Loading...",
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          theme: {
            palette: this.palette,
          },
          xaxis: {
            categories: [
              "0 -30 Jours",
              "31- 90 Jours",
              "91 - 180 Jours",
              "181 - 365 Jours",
              "Plus 1 an",
            ],
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: "10px",
            },
            formatter: function (value) {
              return  value >= 1000 ? parseInt(value/1000) + "K": value;
            },
          },
        },
        series: [
          {
            name: "D&D",
            data: [
              this.units_with_outstanding_recap.reduce(
                (amount, x) => (amount += x.j0_30 == null ? 0 : x.j0_30),
                0
              ),
              this.units_with_outstanding_recap.reduce(
                (amount, x) => (amount += x.j31_90 == null ? 0 : x.j31_90),
                0
              ),
              this.units_with_outstanding_recap.reduce(
                (amount, x) => (amount += x.j91_180 == null ? 0 : x.j91_180),
                0
              ),
              this.units_with_outstanding_recap.reduce(
                (amount, x) => (amount += x.j181_365 == null ? 0 : x.j181_365),
                0
              ),
              this.units_with_outstanding_recap.reduce(
                (amount, x) => (amount += x.j366_0 == null ? 0 : x.j366_0),
                0
              ),
            ],
          },
        ],
      };
    },

  },
   methods: {
    onRefreshOutstanding() {
      this.$store.dispatch("get_units_with_outstanding_recap");
    },
    onRefreshUnitsAtTerminal() {
      this.$store.dispatch("get_units_at_terminal_recap");
    },
    onRefreshUnitsAtConsignee() {
      this.$store.dispatch("get_units_at_Consignee_recap");
    },

    onShowOutstandingDetails: function (carrier_code, client_id) {
      var payload = { carrier: carrier_code, client_id: client_id };
      this.$store.dispatch("get_units_with_outstanding", payload).then(() => {
        this.show_units_with_outstanding = true;
      });
    },
    onShowUnitsAtTerminalDetails: function (carrier_code, client_id) {
      var payload = { carrier: carrier_code, client_id: client_id };
      this.$store.dispatch("get_units_at_terminal", payload).then(() => {
        this.show_units_at_terminal = true;
      });
    },
    onShowUnitsAtConsigneeDetails: function (carrier_code, client_id) {
      var payload = { carrier: carrier_code, client_id: client_id };
      this.$store.dispatch("get_units_at_consignee", payload).then(() => {
        this.show_units_at_consignee = true;
      });
    },
  },
  created() {
    this.$store.dispatch("load_dashboard_data");
  },
};
</script>